import React from 'react';
import { styled } from '@mui/material/styles';
import StarRatingComponent from './StarRatingComponent';
import { Typography } from '@mui/material';

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: '0.8rem',
  margin: theme.spacing(0, 0.5),
  paddingBottom: theme.spacing(0.5),
})) as typeof Typography;

interface IProps<C extends React.ElementType> {
  rating: number;
  totalReviews: number;
  className?: string;
  component: C;
  starSize?: number;
}

const Component = <C extends React.ElementType>(props: IProps<C> & React.ComponentProps<C>) => {
  const { rating, totalReviews, className, starSize, component, ...componentProps } = props;

  const children = (
    <>
      <StarRatingComponent value={rating} readOnly={true} starSize={starSize} />
      <StyledTypography component={'span'} variant={'body2'}>
        ({totalReviews})
      </StyledTypography>
    </>
  );
  return React.createElement(component, {
    ...componentProps,
    className,
    children,
  });
};

const StarRatingWithCount = styled(Component)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'start',
  margin: theme.spacing(0.5, 0),
  cursor: 'pointer',
  outline: 'none',
}));

export default StarRatingWithCount;
